import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import DemographicPromptResponseModel from "../../../Account/Models/DemographicPromptResponseModel";
import { deepCopy } from "../../Utility/DeepCopy";
import { abpnClient } from "../../../../Services/AbpnClient";
import { AuthContext } from "../../../Auth/AuthProvider";
import Physician from "../../../Physician/Models/Physician";

interface IProps {
    physician : Physician;
    setShowDemographicsModal: Function;
    showDemographicsModal: boolean;
}

export default function DemographicsNotification(props : IProps) {

    const history = useHistory();
    const authContext = useContext(AuthContext);


    const onPrimaryActionTaken = () =>{
        history.push('/AccountInformation');

    }
    
    return (<>
        {props.showDemographicsModal && <Modal
            show={props.showDemographicsModal}
            backdrop="static"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            keyboard={false}>
            <Modal.Header>
                <Modal.Title>Submit Data for ABPN Demographic Survey</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    The American Board of Psychiatry and Neurology (ABPN) and its Board of Directors are committed to advancing diversity, equity, and inclusion (DEI) within all ABPN programs and services.
                </p>
                <p>
                    Beginning today, the ABPN will begin collecting detailed demographic data of all ABPN physicians to help enhance ABPN certification programs and the mission of the organization. When logging into the Physician Portal, 
                    you will be asked to submit information on your race, ethnicity, and gender. Survey results will have no bearing on a physician’s certification status. 
                </p>
                <p>
                    The ABPN is committed to using this demographic data to analyze diversity, equity, and inclusion within the certification process and to ensure that all physicians are treated equitably.
                </p>
                <p>
                    The ABPN will not share data that could be used to identify individual residents, training programs, applicants, candidates, diplomates, or former diplomates.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="pp-primary" onClick={onPrimaryActionTaken}>Proceed to Demographic Survey</Button>
            </Modal.Footer>
        </Modal>}
        </>);
}